export enum CREDIT_PRODUCT_TYPE {
  LOAN = 'LOAN',
  CREDIT_CARD = 'CREDIT_CARD',
  AGREEMENT = 'AGREEMENT',
}

export enum CREDIT_PRODUCT_STATUS {
  UNAVAILABLE = 'UNAVAILABLE',
  AVAILABLE = 'AVAILABLE',
  ACTIVE = 'ACTIVE',
}
export enum PAYMENT_PLAN_TYPE {
  STATEMENT = 'STATEMENT',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
}

export enum PAYMENT_TYPE {
  TRANSFER = 'TRANSFER',
  WITHDRAW = 'WITHDRAW',
}

export enum CREDIT_PRODUCT_PAYMENT_TYPE {
  PIX = 'PIX',
  TICKET = 'TICKET',
}

export enum CREDIT_SIMULATION_STATUS {
  WAITING_TRANSFER = 'WAITING_TRANSFER',
  OPEN = 'OPEN',
  WAITING_WITHDRAW = 'WAITING_WITHDRAW',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  REPROVED = 'REPROVED',
}

export enum CREDIT_SIMULATION_STATUS_PT {
  WAITING_TRANSFER = 'Aguardando transferência',
  OPEN = 'Em aberto',
  WAITING_WITHDRAW = 'Aguardando saque',
  CANCELLED = 'Cancelado',
  DONE = 'Finalizado',
  REPROVED = 'Reprovado',
}

export enum CREDIT_PRODUCT_BILL_STATUS {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  IN_AGREEMENT = 'IN_AGREEMENT',
  NOT_PAID = 'NOT_PAID',
}

export enum CREDIT_SIMULATION_METHOD {
  PIX = 'PIX',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  STORE = 'STORE',
}
